// @ts-expect-error TS6133 -- MIGRATION: not approved, fix when encountered
import React from 'react'
import moment from 'moment'
import { sanitizeNoteHtml } from '../../../utils/noteHtmlSanitizer'
import { RemarksAuthor } from './RemarksAuthor'

// @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
export const RemarksContent = ({ remarks }) =>
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  remarks?.remarksList?.map(({ Author, DateTime, Message }, index) => {
    const date = moment(DateTime).format('MM/DD/YYYY hh:mma')
    return (
      // eslint-disable-next-line react/no-array-index-key
      <div key={index}>
        {index ?
          <hr className='remarks-divider' />
        : null}
        <div className='remarks-date-time'>{date}</div>
        {/* eslint-disable-next-line react/no-danger */}
        {!Author && <div className='remarks-message' dangerouslySetInnerHTML={{ __html: sanitizeNoteHtml(Message) }} />}
        {}
        {Author ?
          <div className='remarks-message' dangerouslySetInnerHTML={{ __html: sanitizeNoteHtml(Message) }} />
        : null}
        {Author ?
          <RemarksAuthor data={Author} index={index} />
        : <div className='remarks-author system-generated'>System generated</div>}
      </div>
    )
  })
